import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export const SortIconMenu = ({ options = [], onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    setAnchorEl(null);
    if (event !== undefined) onChange(event);
  };

  return (
    <>
      <IconButton onClick={handleClick} color="inherit">
        <SwapVertIcon sx={{ fontSize: 35 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
      >
        {options.map((option) => {
          return (
            <MenuItem
              key={option.value}
              onClick={() => handleClose({ target: { value: option.value } })}
            >
              {option.text}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
